import React, { useMemo, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';

import FirstStep from './pages/FirstStep';
import SecondStep from './pages/SecondStep';
import ThirdStep from './pages/ThirdStep';
import FourthStep from './pages/FourthStep';
import SuccessPage from './pages/SuccessPage';
import FailPage from './pages/FailPage';
import TermsAndConditions from './pages/TermsAndConditions';
import InformationForConsumer from './pages/InformationForConsumer';
import PersonalDataPolicy from './pages/PersonalDataPolicy';
import TermsOfPayments from './pages/TermsOfPayments';

import NavBar from './components/NavBar/index';
import Footer from './components/Footer';
import { theme } from './constants/theme';
import client from './apollo';
import { InsuranceContext } from './context/insuranceContext';
import { DEFAULT_INSURANCE } from './constants/localeStorageValues';
import { useLocaleStorage } from './hooks/useLocalStorage';
import { INSURANCE_INIT_PARAMS } from './constants/insuranceInitialParams';


const App: React.FC<{}> = () => {
  const selectedTheme = theme; 
  const [insurance, setInsurance] = useLocaleStorage('insurance', DEFAULT_INSURANCE);
  const [
    insuranceParameters, 
    setInsuranceParameters
  ] = useLocaleStorage('insurance-params', INSURANCE_INIT_PARAMS);  

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const value = useMemo(() => (
    {insurance, insuranceParameters, setInsurance, setInsuranceParameters}
    ), [insurance, insuranceParameters, setInsurance, setInsuranceParameters]);

  return (
    <div className='App'>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={selectedTheme}>
          <ApolloProvider client={client}>
            <InsuranceContext.Provider value={value}>
              <Router>
                <div>
                  <NavBar />
                  <Routes>
                    FourthStep
                      <Route path='/' element={<FirstStep />} />
                      <Route path='/offers' element={<SecondStep />} />
                      <Route path='/buy-insurance' element={<ThirdStep />} />
                      <Route path='/confirm-data' element={<FourthStep />} />
                      <Route path='/success' element={<SuccessPage />} />
                      <Route path='/fail' element={<FailPage />} />
                      <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
                      <Route path='/information-for-consumer' element={<InformationForConsumer />} />
                      <Route path='/personal-data-policy' element={<PersonalDataPolicy />} />
                      <Route path='/terms-of-payment-and-payments' element={<TermsOfPayments />} />
                  </Routes>
                  <Footer />
                </div>
              </Router>
            </InsuranceContext.Provider>
          </ApolloProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </div>
  );
};

export default App;
